<template>
  <div>
    <h1>Votre numéro de téléphone</h1>
    <form @submit.prevent="handleSubmit">
      <FormInput
        id="register-mobile-phone"
        v-model="form.mobilePhone"
        :default-country="form.practiceCountry"
        :label="phoneLabel"
        required
        type="tel"
        @blur="$v.form.mobilePhone.$touch()"
        @country-changed="handleCountryChanged"
      >
        <template v-if="$v.form.mobilePhone.$dirty" #error>
          <template v-if="!$v.form.mobilePhone.required">Veuillez entrer un numéro de téléphone</template>
          <template v-else-if="!$v.form.mobilePhone.valid">Le numéro de téléphone est invalide</template>
        </template>
      </FormInput>

      <p class="information" v-if="!isSecretary">
        Votre numéro de téléphone servira à sécuriser l’accès à votre compte. Vous recevrez un
        code de validation par SMS à ce numéro pour vous connecter.
      </p>
      <p class="information" v-if="isSecretary">
        Votre numéro de téléphone servira à sécuriser l’accès à votre compte.
      </p>

      <SignupButtons :can-be-submitted="!$v.$invalid" :is-submitting="isSubmitting" />
    </form>
  </div>
</template>

<script>
  import ButtonGreen from '@/components/ButtonGreen';
  import FormInput from '@/components/Form/FormInput';
  import SignupButtons from '@/components/Signup/SignupButtons';
  import { required } from '@byscripts/vuelidate/lib/validators';
  import PhoneNumber from 'awesome-phonenumber';
  import Auth from "@/api/auth";
  import {getAuthorizeURL} from "@/helpers/tools";

  export default {
    name: 'SignupPhone',
    components: { SignupButtons, FormInput, ButtonGreen },
    data() {
      return {
        isSubmitting: false,
        signupError: false,
        form: {
          mobilePhone: this.$store.state.signup.form.mobilePhone,
          country: this.$store.state.signup.form.country,
        },
      };
    },
    validations: {
      form: {
        mobilePhone: {
          required,
          valid: async (phoneNumber, form) => {
            if (!form.country) {
              return false;
            }

            return (new PhoneNumber(phoneNumber, form.country)).toJSON().valid;
          },
        },
      },
    },
    methods: {
      handleCountryChanged(country) {
        this.form.country = country.iso2;
      },
      async handleSubmit() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          return this.$addError('Veuillez vérifier le formulaire');
        }

        try {
          this.isSubmitting = true;
          this.signupError = false;

          const response = await this.$store.dispatch('authCode/sendCodeForSignup', { mobilePhone: this.form.mobilePhone });
          await this.$store.dispatch('signup/saveForm', { form: this.form });

          if (response.code_required === false) {
            await this.$store.dispatch('signup/register');
            const { email, password } = this.$store.getters['auth/getCredentials'];
            await Auth.login(email, password);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event' : 'subscription_hubspot'
            });
            window.location = getAuthorizeURL();
            return;
          }
          await this.$store.dispatch('signup/goToNextStep');
        } catch (e) {
          this.signupError = true;
        } finally {
          this.isSubmitting = false;
        }
      },
    },
    computed:{
      isSecretary() {
        return this.$store.state.signup.form.type === 'secretary'
      },
      phoneLabel() {
        return this.isSecretary ? "Numéro de téléphone" : "Numéro de téléphone mobile"
      }
    }
  };
</script>

<style lang="scss" scoped>
  .information {
    font-size: 1.4rem;
    opacity: 0.6;
  }
  ::v-deep .signup-buttons.has-back-button{
    @include onMobile{
      column-gap: 3.7rem;
      justify-content: end;
      flex-wrap: wrap;
    }
  }
</style>
